<template lang="html"> <!-- api returns both sort options, filter done on client side -->
  <section class="advanced-options mt-2">
    <div class="advanced-assonance-options mb-2 pb-2" v-if="searchModel==='xxsonance'"> 
      <small class="mb-1">{{hebrew ? 'מצלול' : 'Assonance'}}</small>
      <b-form-checkbox 
        id="assonance-option-ct" 
        v-model="displayAssonance"
        >
        {{hebrew ? 'הצג מילים בעלות מצלול עיצורי' : 'Display assonance results only'}}
      </b-form-checkbox>
      <b-form-checkbox
        id="consonance-option-mt" 
        v-model="displayConsonance"
        >
        {{hebrew ? 'הצג מילים בעלות מצלול תנועתי' : 'Display consonance'}}    
      </b-form-checkbox>            
    </div>
    <div class="advanced-alliteration-options pb-4 mb-3" v-if="searchModel==='alliteration'">
      <small>{{hebrew ? 'מספר עיצורים' : 'Consanents'}}</small>
      <vue-slider
        v-model="maxCons"
        :contained="true"
        :tooltip="'none'"
        :dotSize="16"
        :dragOnClick="true"
        :height="9"
        :min="1"
        :max="3"
        :marks="true"
        :data="data"
        class="mb-2"            
      > <template v-slot:label="{value }">
        <div class="vue-slider-mark-label" :class="{'active':maxCons==value}">{{ value }}</div>
      </template>
      </vue-slider>
    </div>    
  </section>
</template>        
<script lang="js">
  import {Actions} from '@/store/stateChanges' 
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'
  export default  {
    name: 'AdvancedOptions',
    props: [],
    mounted() {

    },   
    data() {
      return {
        data: ['1', '2', '3'],
      }
    },
    components: {
      VueSlider,
    },
    methods: {   
    },  
    computed: {
      hebrew () {
        return this.$settings.hebrew
      },
      searchModel () {
        return this.$store.state.searchModel
      },
      maxCons: {
        get () {
          return this.$store.state.preSubmissionOptions.maxConsonant
        },
        set (value) {
          this.$store.commit('SET_MAX_CONS',  value)
          this.$store.dispatch(Actions.RUN_CHARUZIT)
        }
      },    
      displayConsonance: {
        get () {
          return this.$store.state.preSubmissionOptions.displayConsonance
        },  
        set (value) {
          this.$store.commit('SET_CONSONANCE_MODE',  value)
        }        
      }, 
      displayAssonance: {
        get () {
          return this.$store.state.preSubmissionOptions.displayAssonance
        },  
        set (value) {
          this.$store.commit('SET_ASSONANCE_MODE',  value)
        }
      }  
    }      
  }
  </script>
  <style scoped>
    .advanced-assonance-options,
    .advanced-alliteration-options {
      border-bottom: 1px dashed #c8c8c8;
    }
  </style>